import { styled } from '@mui/material/styles';

export const DrawerHeaderStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(2),
  ...theme.mixins.toolbar,
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(8),
  },
}));
